import React, {Fragment} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import GroheFeatureOptionsType from "./groheFeatureOptionsType";
import {VANITY_TYPES} from "../../../core/constants";
import GroheFeatureOptionsShelfSide from "./groheFeatureOptionsShelfSide";
import GroheFeatureOptionsSide from "./groheFeatureOptionsSide";
import GroheFeatureOptionsShowerPan from "./groheFeatureOptionsShowerPan";
import BacksplashSelect from "../../../../selectionWindow/backsplashSelect";
import {wizardGroupInterface} from "../../../../../interfaces/wizardItemInterface";
import {setWizardSelectedValues} from "../../../../../actions/wizardFunctions";
import GroheFeatureOptionsCabinetSide from "./groheFeatureOptionsCabinetSide";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import GroheFeatureOptionsBodySpray from "./groheFeatureOptionsBodySpray";
import WithUpdateLookCartItem from "../../../hocs/withUpdateLookCartItem";
import GroheFeatureOptionsSlatWall from "./groheFeatureOptionsSlatWall";

const GroheFeatureOptions = (props) => {

  const {lookActiveFeature, isWizard, wizardGroup, setWizardSelectedValues, wizardActiveStep, isLixil,
    groheActiveFeatureQuantity, updateLookCartItem} = props;

  if (!lookActiveFeature) {
    return null
  }

  const wizardOptionClick = (optionFeature) => {
    if (!isWizard || !optionFeature) {
      return
    }
    setWizardSelectedValues({
      [wizardActiveStep]: {
        wizardGroup,
        selectedFeature: optionFeature,
        partId: optionFeature.partId,
        quantity: groheActiveFeatureQuantity,
      }
    });
    updateLookCartItem();
  }

  return (
    <Fragment>
      <GroheFeatureOptionsSide activeFeature={lookActiveFeature} parentOptionClick={wizardOptionClick}/>
      {lookActiveFeature.partId === "vanity_cabinet" && !(isLixil && isWizard) ? <GroheFeatureOptionsCabinetSide activeFeature={lookActiveFeature} parentOptionClick={wizardOptionClick}/> : null}
      <GroheFeatureOptionsType activeFeature={lookActiveFeature} metaName="MatchingFeature" parentOptionClick={wizardOptionClick}/>
      {Object.keys(VANITY_TYPES).includes(lookActiveFeature.partId) ? <GroheFeatureOptionsType activeFeature={lookActiveFeature} metaName="CustomSinkSubCategory" parentOptionClick={wizardOptionClick}/> : null}
      {lookActiveFeature.partId === "vanity_sink" && !(isLixil && isWizard) ? <GroheFeatureOptionsType activeFeature={lookActiveFeature} metaName="MountHoles" parentOptionClick={wizardOptionClick}/> : null}
      {lookActiveFeature.partId === "corner_shelf" || (lookActiveFeature.partId === "body_spray" && !isWizard)
          ? <GroheFeatureOptionsShelfSide activeFeature={lookActiveFeature}/>
          : null}
      {lookActiveFeature.partId === "shower_pan_combo" ? <GroheFeatureOptionsShowerPan activeFeature={lookActiveFeature}
                                                                                       isWizard={isWizard}
                                                                                       parentOptionClick={wizardOptionClick}/> : null}
      {/*{lookActiveFeature.partId === "shower_head" ? <GroheFeatureOptionsType metaName="MountPosition" parentOptionClick={wizardOptionClick}/> : null}*/}
      {lookActiveFeature.partId === "backsplash" ? <BacksplashSelect activeFeature={lookActiveFeature} useButtons={true}/> : null}
      {lookActiveFeature.partId === "body_spray" && isWizard
          ? <GroheFeatureOptionsBodySpray activeFeature={lookActiveFeature}
                                          updateLookCartItem={updateLookCartItem}
                                          parentOptionClick={wizardOptionClick}/>
          : null}
      {lookActiveFeature.partId === "slat_wall"
        ? <GroheFeatureOptionsSlatWall activeFeature={lookActiveFeature}
                                       updateLookCartItem={updateLookCartItem}
                                       parentOptionClick={wizardOptionClick}/>
        : null}
    </Fragment>
  )
};

GroheFeatureOptions.propTypes = {
  isWizard: PropTypes.bool,
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  activeFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store, ownProps) => {
  const {lookActiveFeature} = store.lookState;
  const {wizardActiveStep} = store.wizardState;
  const {isLixil} = store.fabricatorState;
  const {groheActiveFeatureQuantity} = store.groheState;

  return {
    lookActiveFeature: ownProps.activeFeature || lookActiveFeature,
    wizardActiveStep,
    isLixil,
    groheActiveFeatureQuantity,
  };
};

const mapDispatchToProps = {
  setWizardSelectedValues,
}

export default (
    connect(mapStateToProps, mapDispatchToProps)((props) => {
      return (
          <WithUpdateLookCartItem>
            {(updateLookCartItem) => <GroheFeatureOptions {...props} updateLookCartItem={updateLookCartItem}/>}
          </WithUpdateLookCartItem>
      )
    })
)
